import React, { useEffect, useState } from 'react'
import axios from 'axios'

import { Loader } from '../../common/components/loader'
import { ReportTemplateHeader } from '../templates/report-template-header'
import { useStyles } from './markdown-report.style'
import { NarrativeMarkdown } from '../../common/components/narrative-markdown'

export const MarkdownReport = function ({ report }) {
  const classes = useStyles()
  const [mdDocument, setMdDocument] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const containerId = report.containerId

  useEffect(function () {
    let cancel = false
    if (containerId) {
      getContent(containerId).then((content) => {
        if (!cancel) {
          setIsLoading(false)
          setMdDocument(content)
        }
      })
    }
    return () => {
      cancel = true
    }
  }, [containerId])

  async function getContent (containerId) {
    const result = await axios.get(`api/content/${containerId}/file/index.md`)
    return result.data
  }

  return isLoading
    ? (
      <div className="page-content-center">
        <Loader />
      </div>
    )
    : (
      <div className={`flex-auto flex-column ${classes.reportContent}`}>
        <ReportTemplateHeader report={report} />
        <div className={classes.reportBody}>
          <NarrativeMarkdown containerId={containerId} mdDocument={mdDocument} />
        </div>
      </div>
    )
}
